import { useEffect, useState, useCallback } from 'react';
import './ActivePosts.css';

function ActivePosts({ backendUrl }) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [deletingId, setDeletingId] = useState(null);

  const fetchPosts = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      const response = await fetch(`${backendUrl}/get_posts`);
      
      if (!response.ok) {
        throw new Error('Failed to fetch posts');
      }
      
      const data = await response.json();
      setPosts(Array.isArray(data) ? data : data.posts || []);
    } catch (err) {
      console.error(err);
      setError('Failed to load posts. Please try again.');
    } finally {
      setLoading(false);
    }
  }, [backendUrl]);

  useEffect(() => {
    fetchPosts();
  }, [fetchPosts]);

  const handleDelete = async (postId,title) => {
    if (!window.confirm('Are you sure you want to delete this post?')) {
      return;
    }

    try {
      setDeletingId(postId);
      const response = await fetch(`${backendUrl}/delete_post`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ postId, title }),
      });

      if (!response.ok) {
        throw new Error('Failed to delete post');
      }

      setPosts((prevPosts) => prevPosts.filter((post) => post.id !== postId));
    } catch (err) {
      console.error(err);
      alert('Failed to delete post. Please try again.');
    } finally {
      setDeletingId(null);
    }
  };

  if (loading) {
    return (
      <div className="card active-posts-card">
        <div className="loading">Loading posts...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="card active-posts-card">
        <p className="error">{error}</p>
        <button type="button" onClick={fetchPosts}>Retry</button>
      </div>
    );
  }

  return (
    <div className="card active-posts-card">
      <h2 className="active-posts__title">Active Posts</h2>
      {posts.length === 0 ? (
        <p className="muted">No active posts found.</p>
      ) : (
        <div className="posts-grid">
          {posts.map((post) => {
            const postId = post.id;
            const firstImage = post.imageLinks && post.imageLinks.length > 0 ? post.imageLinks[0] : null;
            const imageUrl = firstImage ? firstImage.original : null;
            
            return (
              <div key={postId} className="post-item">
                {imageUrl && (
                  <div className="post-item__image-container">
                    <img 
                      src={imageUrl} 
                      alt={post.title || 'Post image'} 
                      className="post-item__image"
                    />
                  </div>
                )}
                <div className="post-item__content">
                  <h3 className="post-item__title">{post.title || 'Untitled Post'}</h3>
                  <button
                    type="button"
                    className="ghost delete-btn"
                    onClick={() => handleDelete(postId,post.title)}
                    disabled={deletingId === postId}
                  >
                    {deletingId === postId ? 'Deleting...' : 'Delete'}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default ActivePosts;

